module.exports = __webpack_public_path__ + "img/task-signin-banner.3bda0463.svg";